import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EmpresaContextService } from '../services/empresa-context.service';

/**
 * Rede de segurança contra "cair na empresa Infokaw": se a sessão está na área central da nuvem e o
 * usuário tem empresa própria, avisa e leva para a seleção de empresa em vez de deixar ele navegar
 * recebendo "sem acesso" em toda tela.
 */
@Injectable({ providedIn: 'root' })
export class EmpresaContextGuard implements CanActivate, CanActivateChild {

  /** Destino do aviso — não pode ser barrado pelo próprio guard. */
  private static readonly ROTA_SELECAO = '/profile/filial';

  constructor(
    private empresaContext: EmpresaContextService,
    private router: Router
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const url = state?.url ?? '';
    // deveAvisarEmpresaIncorreta() já exige: sessão na central + usuário SEM acesso efetivo lá
    // (só o ROLE_USER que o login cria) + não ter pedido para continuar assim.
    if (url.startsWith(EmpresaContextGuard.ROTA_SELECAO)
      || !this.empresaContext.deveAvisarEmpresaIncorreta()) {
      return of(true);
    }

    return this.empresaContext.temOutraEmpresa$().pipe(
      map((temOutra) => {
        if (!temOutra) {
          // usuário só tem a Infokaw (ex.: suporte): contexto central é legítimo
          return true;
        }
        this.empresaContext.promptEmpresaIncorreta('guard');
        return this.router.parseUrl(EmpresaContextGuard.ROTA_SELECAO);
      }),
      catchError((err) => {
        console.error('EmpresaContextGuard erro', err);
        return of(true);
      })
    );
  }
}
